export const WAIT_FOR_PREVIOUS_USER_MESSAGE =
  'Please wait for the previous user to complete this action.';

type AssignmentLike = {
  userId?: string;
  email?: string;
  level?: number;
  permission?: number;
  status?: string | number;
};

type SlipLike = {
  assignedUsers?: AssignmentLike[];
};

type CurrentUserLike = {
  id?: string;
  email?: string;
};

function readableStatus(
  status: string | number | undefined
): 'Approved' | 'Rejected' | 'Pending' | 'Viewed' {
  if (typeof status === 'string') {
    const statusLower = status.toLowerCase();
    if (statusLower === 'approved') return 'Approved';
    if (statusLower === 'rejected') return 'Rejected';
    if (statusLower === 'viewed') return 'Viewed';
    return 'Pending';
  }
  if (status === 1) return 'Approved';
  if (status === 2) return 'Rejected';
  return 'Pending';
}

/**
 * True when this user is on a later level and an earlier level still has work to do.
 * Same-level approvers are not blocked (parallel approval).
 */
export function isEarlierRoutingLevelPending(
  details: SlipLike | null | undefined,
  currentUser: CurrentUserLike | null | undefined
): boolean {
  const assignments = details?.assignedUsers;
  if (!assignments?.length || !currentUser) {
    return false;
  }

  const mine = assignments.find((user) => {
    if (currentUser.id && user.userId === currentUser.id) {
      return true;
    }
    const email = currentUser.email?.toLowerCase();
    return !!email && user.email?.toLowerCase() === email;
  });
  if (!mine) {
    return false;
  }

  const myLevel = Number(mine.level ?? 1);
  return assignments.some((user) => {
    const level = Number(user.level ?? 1);
    if (level >= myLevel) {
      return false;
    }
    const status = readableStatus(user.status);
    if (Number(user.permission) === 1) {
      return status !== 'Viewed';
    }
    return status !== 'Approved' && status !== 'Rejected';
  });
}
